function openCity(evt, destination) {
  const tabContent = destination.querySelectorAll('.listing-triple__medium, .listing-triple__destination');

  if (evt.currentTarget.htmlFor === 'view-all') {
    tabContent.forEach((item) => {
      // eslint-disable-next-line no-param-reassign
      item.style.display = 'flex';
    });

    return true;
  }

  tabContent.forEach((item) => {
    // eslint-disable-next-line no-param-reassign
    item.style.display = 'none';
  });

  destination.querySelectorAll(`.${evt.currentTarget.htmlFor}`).forEach((item) => {
    // eslint-disable-next-line no-param-reassign
    item.style.display = 'flex';
  });

  return true;
}

const destinations = document.querySelectorAll('.listing-triple');
destinations.forEach((destination) => {
  const tabs = destination.querySelectorAll('.listing-triple__tab');
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      // eslint-disable-next-line no-restricted-globals
      openCity(event, destination);
    });
  });
});
